import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';

const COMPARATIVO = [
  ['Catálogo completo de veículos',          true,  true ],
  ['Fotos e detalhes dos anúncios',           true,  true ],
  ['Contato direto com vendedores',           true,  true ],
  ['Acesso a produtos Heritage',              true,  true ],
  ['Anunciar veículo na plataforma',          false, true ],
  ['Upload de fotos do veículo',              false, true ],
  ['Solicitação de publicação',               false, true ],
  ['Até 5 anúncios inclusos no plano',        false, true ],
  ['Anúncios adicionais (acima de 5)',        false, '+ R$ 5,00/un.'],
  ['Acesso total à plataforma',               false, true ],
];

function CellIcon({ v }) {
  if (typeof v === 'string') {
    return <span style={{ color: 'var(--rust)', fontWeight: 900, fontSize: 12 }}>{v}</span>;
  }
  return <span style={{ color: v ? '#1e7d47' : '#ccc', fontWeight: 900, fontSize: 16 }}>{v ? '✓' : '✗'}</span>;
}

export default function Planos() {
  const { usuario } = useAuth();
  const [params] = useSearchParams();
  const [planos, setPlanos] = useState([]);
  const msg = params.get('msg');

  useEffect(() => {
    api.get('/assinaturas/planos').then(({ data }) => setPlanos(data)).catch(() => {});
  }, []);

  const msgs = {
    assinatura: 'Para acessar essa área, escolha um dos planos de assinatura da Heritage.',
    premium:    'Para anunciar seu veículo, faça upgrade para o plano Premium.',
    trial:      'Seu período de teste encerrou. Escolha um plano para continuar.',
  };

  const basico  = planos.find(p => p.slug === 'basico');
  const premium = planos.find(p => p.slug === 'premium');

  return (
    <>
      <Navbar />
      <div style={{ background: 'var(--cream-dark)', minHeight: 'calc(100vh - 112px)' }}>
        {/* Header */}
        <div className="planos-hero" style={{ background: 'var(--ink)', padding: '64px 0 56px' }}>
          <div className="container" style={{ maxWidth: 820, textAlign: 'center' }}>
            {msg && (
              <div style={{ background: 'rgba(216,189,105,.15)', border: '1px solid rgba(216,189,105,.35)', borderRadius: 'var(--r-sm)', padding: '12px 20px', marginBottom: 28, color: '#d8bd69', fontSize: 14 }}>
                {msgs[msg] || msg}
              </div>
            )}
            <div style={{ color: 'var(--rust)', fontSize: 11, letterSpacing: 2.4, textTransform: 'uppercase', fontWeight: 900, marginBottom: 14 }}>Assinaturas</div>
            <h1 style={{ fontFamily: "'Playfair Display',serif", fontSize: 48, color: '#fff', fontWeight: 600, lineHeight: 1.05, marginBottom: 16 }}>
              Escolha como acessar o universo Heritage.
            </h1>
            <p style={{ color: 'rgba(255,255,255,.6)', fontSize: 16, lineHeight: 1.7, maxWidth: 560, margin: '0 auto' }}>
              7 dias gratuitos em qualquer plano. Cancele quando quiser, sem custo durante o trial.
            </p>
          </div>
        </div>

        {/* Cards */}
        <div className="container" style={{ maxWidth: 900, padding: '0 28px', transform: 'translateY(-32px)' }}>
          <div className="planos-cards-grid">
            {/* Básico */}
            <div className="plan-card-inner">
              <div className="plan-name">Plano Básico</div>
              <div className="plan-price">
                R$ {basico ? Number(basico.valor).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) : '9,90'}
                <small>/mês</small>
              </div>
              <p style={{ color: 'var(--ink-muted)', fontSize: 14, lineHeight: 1.6, marginBottom: 20 }}>
                Para quem quer acessar o catálogo e acompanhar as melhores oportunidades de compra.
              </p>
              <ul>
                {['Catálogo completo de veículos', 'Fotos e detalhes de cada anúncio', 'Contato direto com os vendedores', 'Acesso a produtos Heritage'].map(i => (
                  <li key={i}>{i}</li>
                ))}
              </ul>
              <Link
                to={usuario ? `/checkout?plano=basico` : '/cadastro'}
                className="btn btn-outline"
                style={{ marginTop: 'auto', minHeight: 46, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 900, letterSpacing: 1.6, textTransform: 'uppercase' }}>
                Começar no Básico — 7 dias grátis
              </Link>
            </div>

            {/* Premium */}
            <div className="plan-card-inner featured">
              <div className="plan-badge">Mais completo</div>
              <div className="plan-name">Plano Premium</div>
              <div className="plan-price">
                R$ {premium ? Number(premium.valor).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) : '19,90'}
                <small>/mês</small>
              </div>
              <p style={{ color: 'var(--ink-muted)', fontSize: 14, lineHeight: 1.6, marginBottom: 20 }}>
                Tudo do Básico, mais acesso à área de venda com até 5 anúncios inclusos. Anúncios adicionais por R$ 5,00/un.
              </p>
              <ul>
                {[
                  'Tudo incluído no plano Básico',
                  'Até 5 anúncios inclusos no plano',
                  'Upload de fotos do veículo',
                  'Publicação após aprovação Heritage',
                  'Anúncios extras por R$ 5,00/un.',
                ].map(i => (
                  <li key={i}>{i}</li>
                ))}
              </ul>
              <Link
                to={usuario ? `/checkout?plano=premium` : '/cadastro'}
                className="btn btn-gold"
                style={{ marginTop: 'auto', minHeight: 46, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 900, letterSpacing: 1.6, textTransform: 'uppercase' }}>
                Assinar Premium — 7 dias grátis
              </Link>
            </div>
          </div>

          {/* Trial note */}
          <div style={{ background: '#fff', border: '1px solid var(--border)', borderRadius: 'var(--r-md)', padding: '20px 24px', marginTop: 16, display: 'flex', gap: 14, alignItems: 'flex-start' }}>
            <span style={{ fontSize: 22, flexShrink: 0 }}>🔒</span>
            <p style={{ fontSize: 13, color: 'var(--ink-muted)', lineHeight: 1.65 }}>
              <strong style={{ color: 'var(--ink)' }}>Nenhuma cobrança hoje.</strong> Você cadastra o cartão para garantir o acesso mas o débito só ocorre no 8º dia. Durante os 7 dias de trial você pode cancelar a qualquer momento, gratuitamente.
            </p>
          </div>
        </div>

        {/* Comparativo */}
        <div className="container" style={{ maxWidth: 900, paddingBottom: 80 }}>
          <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: 28, fontWeight: 600, marginBottom: 20, textAlign: 'center' }}>Comparativo completo</h2>
          <div className="tabela-scroll"><table className="tabela">
            <thead>
              <tr>
                <th style={{ width: '56%' }}>Recurso</th>
                <th style={{ textAlign: 'center' }}>Básico</th>
                <th style={{ textAlign: 'center', background: 'rgba(154,86,55,.06)' }}>Premium</th>
              </tr>
            </thead>
            <tbody>
              {COMPARATIVO.map(([rec, b, p]) => (
                <tr key={rec}>
                  <td style={{ fontSize: 14 }}>{rec}</td>
                  <td style={{ textAlign: 'center' }}><CellIcon v={b} /></td>
                  <td style={{ textAlign: 'center', background: 'rgba(154,86,55,.03)' }}><CellIcon v={p} /></td>
                </tr>
              ))}
            </tbody>
          </table></div>
          <p style={{ fontSize: 12, color: 'var(--ink-muted)', textAlign: 'center', marginTop: 20, lineHeight: 1.6 }}>
            A Heritage atua como plataforma de divulgação. A venda dos veículos é direta entre anunciante e comprador, sem intermediação Heritage.
          </p>
        </div>
      </div>
    </>
  );
}
